import { useState, useEffect, Dispatch, SetStateAction } from "react";

export function useLocalStorageState({
    lsKey,
    overrideValue,
    initialValue = null,
}: {
    lsKey: string;
    initialValue?: string | null;
    overrideValue?: string | null;
}): [string | null, Dispatch<SetStateAction<string | null>>] {
    const [state, setState] = useState<string | null>(() => {
        if (overrideValue !== undefined) {
            return overrideValue;
        }

        if (typeof window !== "undefined") {
            const storedValue = localStorage.getItem(lsKey);
            if (storedValue !== null) {
                return storedValue;
            }
        }

        return initialValue;
    });

    useEffect(() => {
        if (state !== null) {
            localStorage.setItem(lsKey, state);
        } else {
            localStorage.removeItem(lsKey);
        }
    }, [state, lsKey]);

    return [state, setState];
}
